import { render, staticRenderFns } from "./PwaInstallIcon.vue?vue&type=template&id=96358338&"
import script from "./PwaInstallIcon.vue?vue&type=script&lang=js&"
export * from "./PwaInstallIcon.vue?vue&type=script&lang=js&"
import style0 from "./PwaInstallIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports